export default __webpack_public_path__ + "static/media/logo_notredame.be09865b.png";